import { FloraTypography } from '@grupoboticario/flora-react';
import { Container } from 'ui/components/primitives';
import { ShareGuide } from './ShareYourGuide.styles';

const ShareYourGuide = ({ banner, link }: { banner: string; link: string }) => {
  return (
    <div>
      <ShareGuide.PreView>Pré-visualização (Enviada para o cliente):</ShareGuide.PreView>
      <ShareGuide.ShareContent>
        <ShareGuide.DivImg>
          <ShareGuide.ShareImg src={banner} alt="Imagem do Catálogo" />
        </ShareGuide.DivImg>
        <ShareGuide.ContentLink>
          <Container marginBottom="sp-0" marginTop="sp-0">
            <FloraTypography fontSize="bodyLargeShort">Oi, Tudo bem?</FloraTypography>
          </Container>
          <Container marginBottom="sp-0" marginTop="sp-4">
            <FloraTypography fontSize="bodyLargeShort">Essa é Minha Loja Digital!</FloraTypography>
          </Container>
          <Container marginBottom="sp-0" marginTop="sp-0">
            <FloraTypography fontSize="bodyLargeShort">
              Veja os produtos e faça seu pedido por lá. É simples e prático.
            </FloraTypography>
          </Container>

          <Container marginBottom="sp-0" marginTop="sp-4">
            <FloraTypography fontSize="bodyLargeShort">{link}</FloraTypography>
          </Container>
        </ShareGuide.ContentLink>
      </ShareGuide.ShareContent>
    </div>
  );
};

export default ShareYourGuide;
